export const groupChart = (batch, group) =>
    batch.reduce((state, event) => {
        state.push(
            group.reduce((s, g, i) => {
                s += `${i ? '-' : ''}${event[g]}`
                return s
            }, '')
        )
        return [...new Set(state)]
    }, [])

const colorSet = n => {
    let i = 1
    for (n; n > 10; i++) n = n - 10 + 0.1 / i

    if (n % 2 === 0) return `hsl(${n * 20 + 160} ,85%,40%)`
    else return `hsl(${Math.abs(n * 20 - 160)} ,85%,40%)`
}

export const seriesChart = (atrr, events, select, group,color) => {    
    return events.map((e, i) => ({
        y: e[select[0]],
        color:e['__color'] || color,
        value:e['__formatted'] || e[select[0]],
        description: e['__description'] || e['__formatted'] || e[select[0]]
    }))
}
